<div class="main-div">
    <mat-card>
        <div class="expander">
            <button mat-raised-button color="secondary" type="button" (click)="accordion.openAll()" class="btn-default">Expand All </button>
            <div class="divider"></div>
            <button mat-raised-button color="secondary" type="button"  (click)="accordion.closeAll()" class="btn-default">Collapse All </button>
        </div>
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Managing player requests
                </mat-expansion-panel-header>
                <p class="accordionContent">Follow the steps below to efficiently manage player requests</p>
                <p>On the home page click on the Player Overview tab</p>
                <p>Once there, refer to the player requests card</p>
                <p>This card shows all active requests that have been made by players at your course</p>
                <p>If a request has been started click on the yellow check mark button on the right of the table</p>
                <p>If a request has been completed click on the purple check mark button on the right of the table</p>
                <p>To clear a request from the table click on the red minus button</p>
                <p>Clicking on this button will permanently remove the request so be certain that the request has been completed</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Viewing active games
                </mat-expansion-panel-header>
                <p class="accordionContent">Follow the steps below to view active games</p>
                <p>On the home page click on the Player Overview tab</p>
                <p>Once there, refer to the active games card</p>
                <p>This card shows all games that are currently in progress at your course</p>
                <p>This table orders by the hole number so it is a good gauge of congestion on your course</p>
                <p>For a more acurate represetation head over to the Course Overview tab and select the Congestion navigation item</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Reading course congestion
                </mat-expansion-panel-header>
                <p class="accordionContent">Follow the steps below to read course congestion data</p>
                <p>In order for the system to estimate wait times you <strong>MUST</strong> have the par number inputted for each hole</p>
                <p>On the home page click on the Course Overview tab</p>
                <p>Once there, you will see a page with tables</p>
                <p>The table titled 'Estimated Wait Time in Minutes' is a line chart backed by live estimates of wait times on your course</p>
                <p><strong>KEEP IN MIND</strong> that this is only an estimate and play speeds will vary for groups</p>
                <p>The x-axis represents the hole number and the y-axis represents time in minutes</p>
                <p>Hovering your mouse over any point will show an information box that gives you the time in minutes</p>
                <p>The table below shows that same information in a different format</p>
                <p>The table titled 'Groups at Hole' shows the amount of groups that are at a hole</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Entering information for your course
                </mat-expansion-panel-header>
                <p class="accordionContent">Follow the steps below to enter or edit course information</p>
                <p>On the home page click on the Course Overview tab</p>
                <p>Once there, click on any of the holes from the nav-bar</p>
                <p>Click on the pencil icon on panel for the hole that you wish to edit</p>
                <p>Enter the details and then click save to save. If there is a mistake you can edit this as many times as you wish</p>
                <p>If the information was saved then the tab will change to a non-editable mode</p>
                <p>If not, then re-enter the information and try again</p>
                <p>This information is what players will see when visiting your course</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Geofencing holes
                </mat-expansion-panel-header>
                <p class="accordionContent">Follow the steps below to draw hole boundaries and place a hole marker</p>
                <p>Navigate to the Course Overview tab</p>
                <p>With any hole selected from the navbar, look at the general information card</p>
                <p>If the geofencing of the hole isn't complete then it will be marked is 'Not Complete'</p>
                <p>To complete geofencing, click on the map icon to launch the map</p>
                <p>First, place a marker on the location of the hole by clicking on the map</p>
                <p>Next, draw the outline of the hole by clicking the polygon icon in the top left</p>
                <p>If a mistake is made the undo button will clear the drawn overlay. The marker is always moveable</p>
                <p>There is a fullsceen button in the top right corner, zoom controls in the bottom right, and a drag button on the top left</p>
                <p>Pressing the close button will close the map window without saving</p>
                <p>When finished hit the save button to save the information</p>
                <p>Each time the map is launched it will be cleared of all previous overlays</p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Change your account's email address
                </mat-expansion-panel-header>
                <ng-container *ngIf="isLoading">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </ng-container>
                <p class="accordionContent">Fill out the form below to change your email address</p>
                <div class="center">
                    <form [formGroup]="emailForm">
                        <div>
                            <mat-form-field class="input">
                                <input matInput placeholder="Email" id="email" name="email" [(ngModel)]="email" type="email" formControlName="email" required>
                                <mat-hint>Enter the new email address</mat-hint>
                                <mat-error>
                                    Enter a valid email address
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field class="input">
                                <input matInput placeholder="Reenter Email" id="email2" name="email2" [(ngModel)]="email2" type="email" formControlName="email2" required>
                                <mat-hint>Reenter the new email address</mat-hint>
                                <mat-error>
                                    Enter a valid email address
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <p *ngIf="emailChanged" class="success">Email has been changed. Verfiy your new credentials by clicking on the link in the email</p>
                        <p *ngIf="emailChanged" class="success">You will not be able to login until doing so</p>
                        <p *ngIf="errorMessage" class="error">{{errorMessage}}</p>
                        <p class="error" *ngIf="noMatchEmail">{{noMatchEmail}}</p>
                        <br *ngIf="!emailChanged && !errorMessage && !noMatchEmail">
                        <br *ngIf="!emailChanged && !errorMessage">
                        <div class="buttons">
                            <button *ngIf="!confirm && !isLoading" mat-raised-button color="primary" type="submit" (click)="confirmChange(true)" class="btn btn-default">Change email</button>
                            <button *ngIf="!isLoading && confirm" mat-raised-button color="warn" type="submit" (click)="changeEmail()" class="btn btn-default">Confirm</button>
                            <div class="divider"></div>
                            <button *ngIf="!isLoading && confirm" mat-raised-button color="secondary" type="submit" (click)="confirmChange(false)" class="btn btn-default">Cancel</button>
                            <button *ngIf="isLoading && confirm" mat-raised-button color="warn" type="submit" class="btn btn-default" disabled>Confirm</button>
                            <div class="divider"></div>
                            <button *ngIf="isLoading && confirm" mat-raised-button color="secondary" type="submit" class="btn btn-default" disabled>Cancel</button>
                        </div>
                    </form>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Change your account's password
                </mat-expansion-panel-header>
                <div>
                    <ng-container *ngIf="isLoadingP">
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </ng-container>
                    <p class="accordionContent">Fill out the form below to change your password</p>
                    <div class="center">
                        <form [formGroup]="resetForm">
                            <div>
                                <mat-form-field class="input">
                                    <input matInput placeholder="Password" id="password" name="password" [type]="hide1 ? 'password' : 'text'" [(ngModel)]="password" type="password" formControlName="password" required>
                                    <mat-icon matSuffix (click)="hide1 = !hide1">{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <mat-hint>Enter the new password</mat-hint>
                                    <mat-error>
                                        Must be at least 6 characters
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field class="input">
                                    <input matInput placeholder="Reenter Password" id="password2" name="password2" [type]="hide2 ? 'password' : 'text'" [(ngModel)]="password2" type="password" formControlName="password2" required>
                                    <mat-icon matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <mat-hint>Renter the new password</mat-hint>
                                    <mat-error>
                                        Must be at least 6 characters
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <p *ngIf="passwordChanged" class="success">Your password has been changed</p>
                            <p *ngIf="errorMessageP" class="error">{{errorMessageP}}</p>
                            <p class="error" *ngIf="noMatch">{{noMatch}}</p>
                            <br *ngIf="!passwordChanged && !errorMessageP && !noMatch">
                            <br>
                            <div class="buttons">
                                <button *ngIf="!confirmP && !isLoading" mat-raised-button color="primary" type="submit" (click)="confirmChangePassword(true)" class="btn btn-default">Change password</button>
                                <button *ngIf="!isLoading && confirmP" mat-raised-button color="warn" type="submit" (click)="changePassword()" class="btn btn-default">Confirm</button>
                                <div class="divider"></div>
                                <button *ngIf="!isLoading && confirmP" mat-raised-button color="secondary" type="submit" (click)="confirmChangePassword(false)" class="btn btn-default">Cancel</button>
                                <button *ngIf="isLoading && confirmP" mat-raised-button color="warn" type="submit" class="btn btn-default" disabled>Confirm</button>
                                <div class="divider"></div>
                                <button *ngIf="isLoading && confirmP" mat-raised-button color="secondary" type="submit" class="btn btn-default" disabled>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Download the mobile app
                </mat-expansion-panel-header>
                <p class="accordionContent">Download the mobile app from <a href="" (click)="appDownload()">Google Play</a></p>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    Contact us
                </mat-expansion-panel-header>
                <!-- Actual email I created so that it looks better -->
                <p class="accordionContent">Email any discovered issues and/or feature requests to us at our support <a href="" (click)="mailTo()">email</a></p>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card>
</div>
